/* ================================================================
   Canvas Galore — Theme JS (vanilla, no dependencies)
   - Scroll reveal
   - Mobile nav
   - WhatsApp FAB
   - Exit-intent voucher modal (localStorage)
   - Preview Studio (sharpness check, true-to-scale room preview)
   - Product-page photo upload (line-item-property)
   ================================================================ */
(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  var revealItems = document.querySelectorAll('.cg-reveal');
  if (revealItems.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      revealItems.forEach(function (el) { io.observe(el); });
    } else {
      revealItems.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Mobile nav ---------- */
  document.querySelectorAll('[data-cg-burger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-cg-burger');
      var menu = document.getElementById(id);
      if (!menu) return;
      menu.classList.toggle('is-open');
    });
  });
  document.querySelectorAll('[data-cg-mobile-menu] a').forEach(function (a) {
    a.addEventListener('click', function () {
      var menu = a.closest('[data-cg-mobile-menu]');
      if (menu) menu.classList.remove('is-open');
    });
  });

  /* ---------- WhatsApp FAB ---------- */
  var fab = document.querySelector('[data-cg-fab]');
  if (fab) {
    var toggleFab = function () {
      if (window.scrollY > 400) fab.classList.add('is-visible');
      else fab.classList.remove('is-visible');
    };
    toggleFab();
    window.addEventListener('scroll', toggleFab, { passive: true });
  }

  /* ---------- Hero parallax (desktop only — mobile clips the image) ---------- */
  var heroImg = document.querySelector('[data-cg-hero-img]');
  if (heroImg && window.matchMedia('(min-width: 1024px)').matches) {
    var raf = 0;
    var onHeroScroll = function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var y = Math.min(window.scrollY * 0.06, 60);
        heroImg.style.transform = 'scale(1.08) translateY(' + y + 'px)';
      });
    };
    window.addEventListener('scroll', onHeroScroll, { passive: true });
  }

  /* ---------- Exit Intent ---------- */
  var exit = document.querySelector('[data-cg-exit]');
  if (exit) {
    var STORAGE_KEY = 'cg-exit-shown-v1';
    var VOUCHER_KEY = 'cg-exit-voucher';
    var openModal = function () {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      sessionStorage.setItem(STORAGE_KEY, '1');
      exit.classList.add('is-open');
    };
    var onLeave = function (e) {
      if (e.clientY <= 0) openModal();
    };
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      document.addEventListener('mouseleave', onLeave);
      // mobile fallback
      setTimeout(function () {
        if (window.matchMedia('(pointer: coarse)').matches) openModal();
      }, 35000);
    }
    exit.addEventListener('click', function (e) {
      if (e.target === exit) exit.classList.remove('is-open');
    });
    exit.querySelectorAll('[data-cg-exit-close]').forEach(function (b) {
      b.addEventListener('click', function () { exit.classList.remove('is-open'); });
    });
    var form = exit.querySelector('[data-cg-exit-form]');
    var errEl = exit.querySelector('[data-cg-exit-error]');
    var codeEl = exit.querySelector('[data-cg-exit-code]');
    var fixedCode = exit.getAttribute('data-voucher-code') || 'SAVE10';
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]').value.trim();
        if (!email || email.indexOf('@') === -1) {
          if (errEl) { errEl.textContent = "That email doesn't look right."; errEl.classList.add('is-visible'); }
          return;
        }
        if (errEl) errEl.classList.remove('is-visible');
        localStorage.setItem(VOUCHER_KEY, fixedCode);
        if (codeEl) codeEl.querySelector('span').textContent = fixedCode;
        exit.classList.add('is-success');
        // also forward to Shopify customer form (hidden iframe target → no navigation)
        var shopifyEmail  = exit.querySelector('[data-cg-exit-shopify-email]');
        var shopifySubmit = exit.querySelector('[data-cg-exit-shopify-submit]');
        if (shopifyEmail && shopifySubmit) {
          shopifyEmail.value = email;
          try { shopifySubmit.click(); } catch (_) {}
        }
      });
    }
    if (codeEl) {
      codeEl.addEventListener('click', function () {
        var txt = codeEl.querySelector('span').textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(txt);
        codeEl.querySelector('[data-cg-exit-copy-ic]').textContent = '✓';
        setTimeout(function () { codeEl.querySelector('[data-cg-exit-copy-ic]').textContent = '⧉'; }, 1800);
      });
    }
  }

  /* ---------- Marquee duplicate items for seamless loop ---------- */
  document.querySelectorAll('[data-cg-marquee]').forEach(function (track) {
    var html = track.innerHTML;
    track.innerHTML = html + html;
  });

  /* ---------- Preview Studio ---------- */
  var SIZES_MM = {
    A5: [148, 210], A4: [210, 297], A3: [297, 420],
    A2: [420, 594], A1: [594, 841], A0: [841, 1189]
  };

  var verdictFor = function (photo, sizeCode) {
    var dims = SIZES_MM[sizeCode] || [297, 420];
    var landscape = photo.w >= photo.h;
    var wMM = landscape ? Math.max(dims[0], dims[1]) : Math.min(dims[0], dims[1]);
    var hMM = landscape ? Math.min(dims[0], dims[1]) : Math.max(dims[0], dims[1]);
    var dpi = Math.min(photo.w / (wMM / 25.4), photo.h / (hMM / 25.4));
    if (dpi >= 150) return { dpi: dpi, level: 'great', label: 'Crisp. Print it.', note: 'Your photo is sharp enough for ' + sizeCode + ' — and then some.' };
    if (dpi >= 100) return { dpi: dpi, level: 'good',  label: 'Good to go.',     note: 'Plenty of detail for a beautiful ' + sizeCode + ' print.' };
    if (dpi >= 60)  return { dpi: dpi, level: 'warn',  label: 'Borderline.',     note: "We'd personally double-check this one before printing at " + sizeCode + ". Try a size down — or send it to us and we'll tell you straight." };
    return                 { dpi: dpi, level: 'bad',   label: 'Too soft for this size.', note: 'At ' + sizeCode + ' this will look blurry. Pick a smaller size, or WhatsApp us the original — phone exports often shrink photos.' };
  };

  var VERDICT_ICONS = {
    great: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>',
    good:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>',
    warn:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
    bad:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
  };

  document.querySelectorAll('[data-cg-studio]').forEach(function (studio) {
    var state = {
      photo: null,
      rangeId: studio.getAttribute('data-default-range') || 'classic',
      size: studio.getAttribute('data-default-size') || 'A2',
      roomId: null
    };

    var ranges = {};
    studio.querySelectorAll('[data-range-config]').forEach(function (el) {
      try { ranges[el.getAttribute('data-id')] = JSON.parse(el.textContent); } catch (_) {}
    });

    var rooms = [];
    studio.querySelectorAll('[data-room-config]').forEach(function (el) {
      try { rooms.push(JSON.parse(el.textContent)); } catch (_) {}
    });
    if (rooms.length) state.roomId = rooms[0].id;

    var stageImg     = studio.querySelector('[data-cg-room-img]');
    var frameEl      = studio.querySelector('[data-cg-frame]');
    var frameImg     = studio.querySelector('[data-cg-frame-img]');
    var framePh      = studio.querySelector('[data-cg-frame-placeholder]');
    var badge        = studio.querySelector('[data-cg-stage-badge]');
    var sizeGroup    = studio.querySelector('[data-cg-sizes]');
    var verdictBox   = studio.querySelector('[data-cg-verdict]');
    var priceVal     = studio.querySelector('[data-cg-price]');
    var priceCap     = studio.querySelector('[data-cg-price-cap]');
    var orderBtn     = studio.querySelector('[data-cg-order-cta]');
    var uploadZone   = studio.querySelector('[data-cg-upload]');
    var uploadInput  = studio.querySelector('[data-cg-upload-input]');
    var uploadCopy   = studio.querySelector('[data-cg-upload-copy]');

    function activeRoom() { return rooms.find(function (r) { return r.id === state.roomId; }) || rooms[0]; }

    function render() {
      var range = ranges[state.rangeId];
      if (!range) return;
      // sizes
      if (sizeGroup) {
        sizeGroup.innerHTML = '';
        range.sizes.forEach(function (s) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cg-pill-size' + (s.code === state.size ? ' is-active' : '');
          btn.textContent = s.code;
          btn.addEventListener('click', function () {
            state.size = s.code;
            render();
          });
          sizeGroup.appendChild(btn);
        });
      }
      // ensure size still exists in this range
      var sizeRow = range.sizes.find(function (s) { return s.code === state.size; });
      if (!sizeRow) { state.size = range.sizes[range.sizes.length - 1].code; sizeRow = range.sizes.find(function (s) { return s.code === state.size; }); }
      // range pills active state
      studio.querySelectorAll('[data-cg-range]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-cg-range') === state.rangeId);
      });
      // room
      var room = activeRoom();
      if (stageImg && room) { stageImg.src = room.img; stageImg.alt = room.name; }
      // frame geometry
      var dims = SIZES_MM[state.size] || [297, 420];
      var landscape = state.photo ? state.photo.w >= state.photo.h : true;
      var wMM = landscape ? Math.max(dims[0], dims[1]) : Math.min(dims[0], dims[1]);
      var hMM = landscape ? Math.min(dims[0], dims[1]) : Math.max(dims[0], dims[1]);
      var wPct = (wMM / (room.sceneMM || 3400)) * 100;
      var ratio = wMM / hMM;
      if (frameEl) {
        frameEl.setAttribute('data-range', state.rangeId);
        frameEl.style.left = (room.x || 50) + '%';
        frameEl.style.top  = (room.y || 33) + '%';
        frameEl.style.width = wPct + '%';
        frameEl.style.aspectRatio = ratio.toString();
      }
      if (frameImg && framePh) {
        if (state.photo) { frameImg.style.display = 'block'; frameImg.src = state.photo.url; framePh.style.display = 'none'; }
        else             { frameImg.style.display = 'none';  framePh.style.display = 'grid'; }
      }
      if (badge) badge.textContent = state.size + ' · ' + range.name + ' · true to scale';
      // price
      if (priceVal) priceVal.textContent = 'R' + Number(sizeRow.price).toLocaleString('en-ZA');
      if (priceCap) priceCap.textContent = state.size + ' ' + range.name;
      if (orderBtn) {
        var base = orderBtn.getAttribute('data-wa-base') || 'https://wa.me/27681771458?text=';
        var msg  = 'Hi Canvas Galore! I previewed my photo in your studio tool — I\'d like a ' + state.size + ' ' + range.name + ' canvas';
        if (state.photo) msg += ' (photo is ' + state.photo.w + '×' + state.photo.h + 'px)';
        msg += '.';
        orderBtn.href = base + encodeURIComponent(msg);
      }
      // verdict
      if (verdictBox) {
        if (!state.photo) {
          verdictBox.innerHTML = ''
            + '<div class="cg-verdict__msg" style="align-items:center"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="color:var(--cg-gold)"><path d="M3 12a9 9 0 0 1 14.65-7"/><polyline points="20 3 20 9 14 9"/><path d="M21 12a9 9 0 0 1-14.65 7"/><polyline points="4 21 4 15 10 15"/></svg><p style="font-size:14px;color:var(--cg-mute);font-weight:300;line-height:1.6">Upload a photo to get an instant, honest sharpness check — same one we run in the studio.</p></div>';
        } else {
          var v = verdictFor(state.photo, state.size);
          verdictBox.innerHTML = ''
            + '<div class="cg-verdict__msg lvl-' + v.level + '">'
            +   VERDICT_ICONS[v.level]
            +   '<div><h5>' + v.label + ' <small>(' + Math.round(v.dpi) + ' DPI at ' + state.size + ')</small></h5><p>' + v.note + '</p></div>'
            + '</div>';
        }
      }
    }

    // range buttons
    studio.querySelectorAll('[data-cg-range]').forEach(function (b) {
      b.addEventListener('click', function () { state.rangeId = b.getAttribute('data-cg-range'); render(); });
    });
    // room buttons
    studio.querySelectorAll('[data-cg-room]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.roomId = b.getAttribute('data-cg-room');
        studio.querySelectorAll('[data-cg-room]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    });
    // first room active
    var firstRoom = studio.querySelector('[data-cg-room]');
    if (firstRoom) firstRoom.classList.add('is-active');

    // upload
    var loadFile = function (file) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) return;
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        if (state.photo && state.photo.url) URL.revokeObjectURL(state.photo.url);
        state.photo = { url: url, w: img.naturalWidth, h: img.naturalHeight };
        if (uploadCopy) uploadCopy.textContent = 'Swap your photo';
        render();
      };
      img.src = url;
    };
    if (uploadZone) {
      uploadZone.addEventListener('click', function () { uploadInput && uploadInput.click(); });
      uploadZone.addEventListener('dragover', function (e) { e.preventDefault(); uploadZone.classList.add('is-drag'); });
      uploadZone.addEventListener('dragleave', function () { uploadZone.classList.remove('is-drag'); });
      uploadZone.addEventListener('drop', function (e) {
        e.preventDefault(); uploadZone.classList.remove('is-drag');
        loadFile(e.dataTransfer.files && e.dataTransfer.files[0]);
      });
    }
    if (uploadInput) {
      uploadInput.addEventListener('change', function (e) { loadFile(e.target.files && e.target.files[0]); });
    }

    render();
  });

  /* ---------- Product-page photo upload (line-item-property) ---------- */
  document.querySelectorAll('[data-cg-photo-upload]').forEach(function (root) {
    var input   = root.querySelector('input[type="file"]');
    var zone    = root.querySelector('[data-cg-pu-zone]');
    var preview = root.querySelector('[data-cg-pu-preview]');
    var thumb   = root.querySelector('[data-cg-pu-thumb]');
    var name    = root.querySelector('[data-cg-pu-name]');
    var verdictEl = root.querySelector('[data-cg-pu-verdict]');
    var removeBtn = root.querySelector('[data-cg-pu-remove]');
    var sizeSel = root.querySelector('[data-cg-pu-size]');
    var sizeFromVariant = root.getAttribute('data-default-size') || 'A3';

    function checkVerdict(photo) {
      if (!verdictEl) return;
      var size = sizeSel ? sizeSel.value : sizeFromVariant;
      var v = verdictFor(photo, size);
      verdictEl.textContent = v.label + ' · ' + v.note;
      verdictEl.className = 'cg-photo-upload__verdict lvl-' + v.level;
    }

    if (zone && input) {
      zone.addEventListener('click', function () { input.click(); });
      zone.addEventListener('dragover', function (e) { e.preventDefault(); root.classList.add('is-drag'); });
      zone.addEventListener('dragleave', function () { root.classList.remove('is-drag'); });
      zone.addEventListener('drop', function (e) {
        e.preventDefault(); root.classList.remove('is-drag');
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          input.files = e.dataTransfer.files;
          input.dispatchEvent(new Event('change'));
        }
      });
    }
    if (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          if (thumb) thumb.src = url;
          if (name) name.textContent = file.name;
          if (preview) preview.classList.add('is-visible');
          if (zone) zone.style.display = 'none';
          checkVerdict({ w: img.naturalWidth, h: img.naturalHeight });
        };
        img.src = url;
      });
    }
    if (removeBtn && input) {
      removeBtn.addEventListener('click', function () {
        input.value = '';
        if (preview) preview.classList.remove('is-visible');
        if (zone) zone.style.display = 'block';
        if (verdictEl) { verdictEl.textContent = ''; verdictEl.className = 'cg-photo-upload__verdict'; }
      });
    }
    if (sizeSel) {
      sizeSel.addEventListener('change', function () {
        if (input && input.files && input.files[0]) {
          var url = URL.createObjectURL(input.files[0]);
          var img = new Image();
          img.onload = function () { checkVerdict({ w: img.naturalWidth, h: img.naturalHeight }); };
          img.src = url;
        }
      });
    }
  });

})();
